export const HOME_ROUTE = '/';
export const MAIN_MENU_ROUTE = '/main-menu';
export const TIMETABLE_ROUTE = '/timetable';

export const COURSES_STORE_ROUTE = '/courses-store';
export const COURSES_DETAIL_ROUTE = '/courses-detail';
export const COURSES_OPTIONS_ROUTE = '/courses-options';
export const COURSES_CART_ROUTE = '/courses-cart';

export const COURSES_SUBJECT_COURSES = '/:subject_id/courses';

export const COURSES_THEMES = '/themes';
export const COURSES_THEMES_ID = '/themes/:id';

export const MY_COURSES_ROUTE = '/my-courses';
export const VIDEO_CARD_ROUTE = '/video-card';
export const HOMEWORK_ROUTE = '/homework';
export const LESSON_ROUTE = '/lesson';

export const PAGE404_ROUTE = '/404';
export const PAGE403_ROUTE = '/403';
